<template>
  <LineChartGenerator
    :chart-options="getChartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
    ref="lineChart"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  TimeScale,
  TimeSeriesScale
} from "chart.js";

import { themeObserver, Themes } from "../../commons/colors";
import "luxon";
import "chartjs-adapter-luxon";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  TimeScale,
  TimeSeriesScale
);
ChartJS.defaults.font.family = "ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, 'Apple Color Emoji', Arial, sans-serif, 'Segoe UI Emoji', 'Segoe UI Symbol'";
ChartJS.defaults.font.size = 12;

export default {
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    horizontal: Boolean,
    chartOptions: Object,
    chartData: Object,
  },
  data: () => ({
    observer: null,
    color: Themes.light.gray700,
    borderColor: Themes.light.gray100,
    lineColor: Themes.light.gray400,
  }),
  methods: {
    updateChart() {
      this.$refs.lineChart.updateChart();
    },
  },
  computed: {
    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        borderWidth: 1,
        borderColor: this.lineColor,
        color: this.color,
        pointBorderWidth: 0,
        indexAxis: this.horizontal ? "y" : "x",
        cubicInterpolationMode: 'monotone',
        scales: {
          x: {
            adapters: {
              date: {},
            },
            /* issue */
            // type: "timeseries",
            // time: {
            //   displayFormats: {
            //     day: "y-LL-dd",
            //   },
            //   unit: "day",
            //   stepSize: 1,
            //   // parser: function(x) {
            //   //   return Date(x).toString()
            //   // }
            // },
            grid: {
              color: this.borderColor,
              borderColor: this.borderColor,
            },
            ticks: {
              color: this.color,
              source: 'labels'
            },
          },
          y: {
            grid: {
              color: this.borderColor,
              borderColor: this.borderColor,
            },
            ticks: {
              color: this.color,
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          tooltip: {
            boxWidth: 6,
            boxHeight: 6,
            boxPadding: 3,
            usePointStyle: true,
          }
        },
        ...this.chartOptions,
      };
    },
  },
  mounted() {
    const target = document.body;
    const setColor = () => {
      if (target.classList.contains("dark")) {
        this.color = Themes.dark.gray700;
        this.borderColor = Themes.dark.gray100;
        this.lineColor = Themes.dark.gray400;
      } else {
        this.color = Themes.light.gray700;
        this.borderColor = Themes.light.gray100;
        this.lineColor = Themes.light.gray400;
      }
    };
    setColor();
    /* mutation observer */
    this.observer = themeObserver(target, setColor, "line");
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
};
</script>